// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../config/styles';

const styles = theme => ({
  mainContainer: {
    width: '100%',
    position: 'relative',
  },
  popup: {
    position: 'absolute',
    zIndex: 10,
    maxWidth: 520,
    width: 520,
    maxHeight: 250,
    overflowY: 'scroll',
    display: 'flex',
    flexDirection: 'column',
    color: GlobalStyles.color.COLOR_GREY,
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    top: 75,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.5)',
    borderRadius: 10,
    [theme.breakpoints.down(550)]: {
      width: 400,
      left: -10,
    },
    [theme.breakpoints.down(430)]: {
      width: 320,
    },
  },
  left: {
    left: -70,
  },
  searchResult: {
    borderBottom: '.5px solid rgb(220, 220, 220)',
    padding: '5px 10px',
    maxHeight: 35,
    minHeight: 35,
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer',
    backgroundColor: GlobalStyles.color.COLOR_PRIMARY,
    '&:hover': {
      backgroundColor: GlobalStyles.color.COLOR_BLUE_LIGHTER,
    }
  },
  popupLabel: {
    margin: '0 10px',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
  },
  labelStyle: {
    width: '100%',
  },
  count: {
    display: 'flex',
    alignItems: 'center',
  },
  more: {
    display: 'flex',
    width: 10,
    height: 15,
    marginLeft: 10,
  }
});

export default styles;
